"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingOperation = void 0;
var account_1 = require("../account");
var content_1 = require("../content");
var billing_transaction_1 = require("./billing-transaction");
var interfaces_1 = require("./interfaces");
/**
 * Операция над счетами пользователя
 * Вообще здесь надо почистить, много информации, которые не применяются в каждой операции,
 * есть возможность почистить.
 */
var BillingOperation = /** @class */function () {
  function BillingOperation(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'operation_group_id', 'billing_profile_id', 'operation', 'amount', 'currency_id', 'amount_credits', 'status', 'note', 'meeting_id', 'user_service_id', 'plan_id', 'reward_action'];
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.created_at = values.created_at instanceof Date ? values.created_at : new Date(values.created_at);
    instance.billing_profile = values.account ? new account_1.User(values.account) : null;
    instance.account = values.account ? new account_1.User(values.account) : null;
    instance.meeting = values.meeting ? new content_1.Meeting(values.meeting) : null;
    instance.transactions = (values.transactions || []).map(function (v) {
      return new billing_transaction_1.BillingTransaction(v);
    });
    instance.plan = values.plan;
    instance.receipt = new interfaces_1.CReceipt(values.receipt);
  }
  return BillingOperation;
}();
exports.BillingOperation = BillingOperation;
